import { render, staticRenderFns } from "./MathMinigame.vue?vue&type=template&id=a110b9b2&scoped=true"
import script from "./MathMinigame.vue?vue&type=script&lang=js"
export * from "./MathMinigame.vue?vue&type=script&lang=js"
import style0 from "./MathMinigame.vue?vue&type=style&index=0&id=a110b9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a110b9b2",
  null
  
)

export default component.exports